import { freeze } from '@reduxjs/toolkit';

/**
 * Caprica theme that follows the styleguide:
 * https://www.figma.com/design/RRRNU3WzvBeMZGbiweC7FG/Bits---Components-Library
 */
export const theme = freeze(
  {
    colors: {
      mainBlue: 'var(--color-main-blue)',
      blue900: 'var(--color-blue-900)',
      blue500: 'var(--color-blue-500)',
      secondary900: 'var(--color-secondary-900)',
      secondary800: 'var(--color-secondary-800)',
      secondary600: 'var(--color-secondary-600)',
      secondary400: 'var(--color-secondary-400)',
      secondary300: 'var(--color-secondary-300)',

      level0: 'var(--color-level-0)',
      level1: 'var(--color-level-1)',
      level2: 'var(--color-level-2)',
      inverse: 'var(--color-inverse)',
      border: 'var(--color-border)',
      tableHeader: 'var(--color-table-header)',
      contentHighlight: 'var(--color-content-highlight)',

      white: '#fff',
      tooltip: '#4C5562',

      primaryBlack: '#111111',
      primaryNavy: '#292d48',
      primaryRed: '#ff5a47',
      grayscale100: 'var(--grayscale-100)',
      grayscale200: 'var(--grayscale-200)',
      grayscale300: 'var(--grayscale-300)',
      grayscale400: 'var(--grayscale-400)',
      grayscale500: 'var(--grayscale-500)',
      grayscale600: 'var(--grayscale-600)',
      grayscale700: 'var(--grayscale-700)',
      grayscale800: 'var(--grayscale-800)',
      grayscale900: 'var(--grayscale-900)',
      grayscale1000: 'var(--grayscale-1000)',
      green100: 'var(--green-100)',
      green200: 'var(--green-200)',
      green300: 'var(--green-300)',
      green400: 'var(--green-400)',
      green500: 'var(--green-500)',
      green600: 'var(--green-600)',
      green700: 'var(--green-700)',
      green800: 'var(--green-800)',
      green900: 'var(--green-900)',
      purple100: 'var(--purple-100)',
      purple200: 'var(--purple-200)',
      purple300: 'var(--purple-300)',
      purple400: 'var(--purple-400)',
      purple500: 'var(--purple-500)',
      purple600: 'var(--purple-600)',
      purple700: 'var(--purple-700)',
      purple800: 'var(--purple-800)',
      purple900: 'var(--purple-900)',
      purple1000: 'var(--purple-1000)',
      red100: 'var(--red-100)',
      red200: 'var(--red-200)',
      red300: 'var(--red-300)',
      red400: 'var(--red-400)',
      red500: 'var(--red-500)',
      red600: 'var(--red-600)',
      red700: 'var(--red-700)',
      red800: 'var(--red-800)',
      red900: 'var(--red-900)',
    },
    effects: {
      shadow1: 'var(--shadow-1)',
      shadow2: 'var(--shadow-2)',
      shadow3: 'var(--shadow-3)',
    },
    charts: {
      dataTable: {
        horizontalBars: '#90BDF9',
      },
    },
  },
  true,
);
